import { createFileRoute } from "@tanstack/react-router";
import React, { Suspense, lazy } from "react";
import SiteHeader from "@/components/common/SiteHeader";
import { useBuildingDetailQuery } from "@/queries/queries";

// Wave-17 Item 1.1 — LL88 overview lazy-loaded.
const LL88SubmissionOverviewPage = lazy(
  () => import("@/pages/Filings/LL88Submission/Overview/Page"),
);

const LL88SubmissionOverviewPageRoute = () => {
  const { buildingId, ll88SubmissionId } = Route.useParams();
  const { data } = useBuildingDetailQuery(buildingId);
  return (
    <div className="flex flex-col w-full min-h-full">
      <SiteHeader
        header={`${data?.name || "Building"} - LL88 Filing`}
        backLink={`/buildings/${buildingId}`}
      />
      <Suspense fallback={null}>
        <LL88SubmissionOverviewPage
          buildingId={buildingId}
          submissionId={ll88SubmissionId}
        />
      </Suspense>
    </div>
  );
};

export const Route = createFileRoute(
  "/buildings_/$buildingId/ll88_/$ll88SubmissionId/overview",
)({
  component: LL88SubmissionOverviewPageRoute,
});
